import { render, staticRenderFns } from "./renliandenglu.vue?vue&type=template&id=b0569716&scoped=true"
import script from "./renliandenglu.vue?vue&type=script&lang=js"
export * from "./renliandenglu.vue?vue&type=script&lang=js"
import style0 from "./renliandenglu.vue?vue&type=style&index=0&id=b0569716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0569716",
  null
  
)

export default component.exports